import request from '@/utils/server'
 

// 新增生产任务
export function getRecord(query) {
    return request({
      url: '/procurement/getRecord',
      method: 'get',
    params:query
    })
  }